export const SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS = {
	// Planner
	hasDismissedPlannerOnce: 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce',
	hasDismissedPlannerPermanently:
		'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
	hasDismissedDiscoveryAndFeedbackOnce:
		'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce',
	hasDismissedDiscoveryAndFeedbackPermanently:
		'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently',
	hasShownTechWriterContentIds: 'suggest-agent-based-on-page-title:hasShownTechWriterContentIds',
	catalogState: 'suggest-agent-based-on-page-title:catalogState',
} as const;

export const SuggestAgentBasedOnPageTitleOnboardingKeys: readonly (
	| 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce'
	| 'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently'
	| 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce'
	| 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently'
	| 'suggest-agent-based-on-page-title:hasShownTechWriterContentIds'
	| 'suggest-agent-based-on-page-title:catalogState'
)[] = Object.values(SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS);

export const SuggestAgentBasedOnPageTitlePermanentDismissalKeys: readonly [
	'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
	'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently',
] = [
	SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS.hasDismissedPlannerPermanently,
	SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS.hasDismissedDiscoveryAndFeedbackPermanently,
] as const;
